import {AfterViewInit, Component, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {UnidadesMedidasModel} from "./unidades-medidas.model";
import {UnidadesMedidasService} from './unidades-medidas.service';
import {Funcoes} from "../funcoes";
import {PaisesService} from "../paises/paises.service";
import {Global} from "../global";

declare let $: any;

@Component({
  selector: 'app-unidades-form',
  templateUrl: './unidades-medidas-form.component.html'
})
export class UnidadesMedidasFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  unidade: UnidadesMedidasModel = new UnidadesMedidasModel();
  listPaises = [];
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  formBuilder;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private unidadesService: UnidadesMedidasService,
    private paisesService: PaisesService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {

    this.formBuilder = formBuilder;

    this.form = formBuilder.group({
      id_unidade: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      sigla: ['', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(45)
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_unidade'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarUnidade');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarUnidade') : this.func.traduzir('front.cadastrarNovaUnidade');
      }


      this.paisesService.get()
        .subscribe(
          json => {
            this.listPaises = json.Payload;

            if(this.global.debug == true){
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });

      if (!id) {
        return;
      }

      this.unidadesService.getById(id, ['notificacoes', 'tipos'])
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarUnidade')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarUnidade')+': '+json.Payload[0].nome;
            }

            this.unidade = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {

    this.enviando = true;
    console.log(this.unidade);
    console.log(JSON.stringify(this.unidade));

    let result,
      //values = this.form.value;
      values = this.unidade;

    if (values.id_unidade) {
      result = this.unidadesService.editar(values, values.id_unidade);
    } else {
      result = this.unidadesService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'unidades-medidas']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/unidades-medidas/unidades-medidas-form.component.ts